import { render, staticRenderFns } from "./leave-details.vue?vue&type=template&id=f5c704ac&scoped=true&"
import script from "./leave-details.vue?vue&type=script&lang=js&"
export * from "./leave-details.vue?vue&type=script&lang=js&"
import style0 from "./leave-details.vue?vue&type=style&index=0&id=f5c704ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c704ac",
  null
  
)

export default component.exports